export class ConnectionDropError extends Error {
  constructor(message = "Connection dropped") {
    super(message);
    this.name = "ConnectionDropError";
  }
}
